<template>
    <div>
        <menu-bar/>
        <div class="container" role="main" v-if="condominio">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a :href="'#/'"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a :href="'#/condominios'"><i class="fa fa-suitcase" aria-hidden="true"></i> CONDOMÍNIOS</a></li>
                    <li class="active">CADASTRO DE CONDOMÍNIO</li>
                </ol>

                <div v-if="!bloco">
                    <go-back  :url="'#/condominios'"/> &nbsp;
                    <button type="button" v-if="user.level === 1"
                            @click="save()" class="btn btn-success">
                        <i class="fa fa-save" aria-hidden="true"></i> SALVAR CONDOMÍNIO
                    </button>
                    <br/><br/>
                </div>

                <form class="form-horizontal" >

                    <div class="panel panel-info" v-if="!bloco">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                        </div>

                        <div class="panel-body">
                            <div class="form-group">

                                <div class="col-sm-12">
                                    <label for="nome" class="control-label">NOME DO CONDOMÍNIO</label>
                                    <input id="nome" autocomplete="off" type="text" v-model="condominio.nome" class="form-control" >
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> BLOCOS CADASTRADOS
                        </div>

                        <div class="panel-body">

                            <div class="row" v-if="bloco">
                                <div class="col-sm-12">
                                    <bloco :bloco="bloco" @clear="bloco = null" @save="addbloco($event)" />
                                </div>
                            </div>

                            <div class="row" v-else>
                                <div class="col-sm-12" >
                                    <button type="button" @click="novoBloco()" class="btn btn-primary">
                                        ADICIONAR BLOCO
                                    </button>
                                </div>

                                <hr>
                                <div class="col-sm-12" v-if="!condominio.blocos.length">
                                    <h2 class="text-danger">NENHUM BLOCO ADICIONADO</h2>
                                </div>

                                <div class="col-sm-12" v-else>
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th>NOME</th>
                                            <th style="width: 100px" class="text-center">ANDARES</th>
                                            <th style="width: 120px" class="text-center">QTDE CAIXAS</th>
                                            <th style="width: 180px" class="text-center">AÇÕES</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="c in condominio.blocos" v-bind:key="c.numero">
                                                <td>BLOCO: {{c.numero}}</td>
                                                <td class="text-center">{{c.andares}}</td>
                                                <td class="text-center">{{c.caixas.length}}</td>
                                                <td class="text-center">
                                                    <button @click="bloco = c" class="btn btn-warning btn-xs" type="button">
                                                        EDITAR
                                                    </button> &nbsp;
                                                    <button @click="delbloco(c)" class="btn btn-danger btn-xs" type="button">
                                                        REMOVER
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>

                    <place v-if="!bloco" :place.sync="condominio.place" :height="'500px'" />

                    <div class="form-group" v-if="!bloco">
                        <div class="col-sm-10">
                            <button type="button" v-if="user.level === 1"
                                    @click="save()" class="btn btn-success">
                                <i class="fa fa-save" aria-hidden="true"></i> SALVAR CONDOMÍNIO
                            </button>
                        </div>
                    </div>

                </form>

            </div>

        </div>
    </div>
</template>
<script>
import { Condominios } from "../../../class/condominios";
import Bloco from "./components/Bloco";
import { Place } from "../../../components/exports";
import GoBack from "../../../components/buttons/goback";

export default {
    components: {
        Place,
        Bloco,
        GoBack
    },
    data() {
        return {
            user: null,
            condominio: null,
            bloco: null,
            nome_pacpon: null,
            caixas: []
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.condominio = Condominios.create();
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async load(id) {
            this.condominio = await Condominios.byID(id);
        },
        addbloco(b) {
            this.delbloco(b);
            this.condominio.blocos.push(b);
            this.bloco = null;
        },
        delbloco(b) {
            this.condominio.blocos.forEach(c => {
                console.log(b.numero === c.numero, b.numero, c.numero);
                if (b.numero === c.numero) {
                    this.condominio.blocos.splice(
                        this.condominio.blocos.indexOf(c),
                        1
                    );
                }
            });
        },
        novoBloco() {
            this.bloco = {
                numero: null,
                andares: null,
                caixas: []
            };
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o condomínio?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Condominios.save(this.condominio)
                                .then(() => {
                                    resolve();
                                    this.$router.push({
                                        path: "/condominios"
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
